import { GitCompare } from "lucide-react";
import { dietTotals } from "@/lib/diet";
import { fmt } from "@/lib/format";

const METRICS = [
  ["Calorie", "kcal", 0, ""],
  ["Carboidrati", "carbo", 1, "g"],
  ["Proteine Animali", "protAnimali", 1, "g"],
  ["Grassi", "grassi", 1, "g"],
  ["Prot. Vegetali (escluse)", "protVegetali", 1, "g"],
];

export default function ConfrontoTab({ diets, macroGrams, calorieTarget }) {
  const totals = (diets || []).map((d) => ({ d, t: dietTotals(d) }));

  return (
    <div className="space-y-5" data-testid="tab-confronto">
      <section className="panel p-5 sm:p-6">
        <h2 className="mb-4 flex items-center gap-2 font-display text-lg font-bold">
          <GitCompare className="h-5 w-5 text-primary" /> Confronto Diete
        </h2>

        <div className="mb-5 flex flex-wrap items-center gap-3 rounded-lg border border-white/5 bg-black/20 px-4 py-2.5 text-sm">
          <span className="text-muted-foreground">Target:</span>
          <span className="font-mono-num text-foreground">{fmt(calorieTarget)} kcal</span>
          <span className="font-mono-num text-[hsl(var(--c-carb))]">C {fmt(macroGrams.carbG)}g</span>
          <span className="font-mono-num text-[hsl(var(--c-prot))]">P {fmt(macroGrams.protG)}g</span>
          <span className="font-mono-num text-[hsl(var(--c-fat))]">G {fmt(macroGrams.fatG)}g</span>
        </div>

        {totals.length === 0 ? (
          <div className="rounded-lg border border-dashed border-white/10 py-10 text-center text-sm text-muted-foreground">
            Nessuna dieta da confrontare.
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full min-w-max text-sm" data-testid="compare-table">
              <thead>
                <tr className="border-b border-white/10 text-xs text-muted-foreground">
                  <th className="py-2 pr-6 text-left font-medium">Macro</th>
                  {totals.map(({ d }, i) => (
                    <th key={d.id} className="min-w-[110px] px-4 py-2 text-right font-semibold text-[hsl(var(--c-teal))]" data-testid={`compare-col-${i}`}>{d.nome}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {METRICS.map(([label, key, dec, unit]) => (
                  <tr key={label} className="border-b border-white/5">
                    <td className="py-2.5 pr-6 text-muted-foreground">{label}</td>
                    {totals.map(({ t }, i) => (
                      <td key={i} className="px-4 py-2.5 text-right font-mono-num" data-testid={`compare-${i}-${key}`}>
                        {fmt(t[key], dec)}{unit}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
